<template>
    <v-dialog
        :value="dialog"
        max-width="650"
        @input="closeDialog"
        >
        <v-card>
            <v-card-title class="headline text-center justify-center" > 
                <div class="text-center" > Согласие на обработку персональных данных </div>
                    <v-btn icon @click="closeDialog" class="close-dialog-button" absolute >
                        <v-icon >mdi-close</v-icon>
                    </v-btn>
            </v-card-title>
        <v-card-actions  class="justify-center">
            <v-spacer></v-spacer>
            <div class="text-center" style="text-align: justify !important">
              Настоящим я, свободно, своей волей и в своем интересе, руководствуясь ст. 9 Федерального закона от 27.07.2006 №152-ФЗ "О персональных данных" даю согласие   АО «Татэнергосбыт», находящемуся по адресу: г. Казань, ул. Павлюхина 110В, ИНН 1657082308, ОГРН 1091690003481 (далее Оператор), на обработку моих персональных данных с целью регистрации и предоставления доступа в личный кабинет на официальном сайте АО "Татэнергосбыт".
              Настоящее согласие действует на период всего срока наличия личного кабинета на официальном сайте Оператора.
              Перечень моих персональных данных, на обработку которых я даю согласие:<br>
              - фамилия, имя, отчество;<br>
              - номер телефона;<br>
              - адрес электронной почты.<br>
              Разрешаю оператору производить автоматизированную, а также осуществляемую без использования средств автоматизации обработку моих персональных данных, а именно: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, удаление, уничтожение.<br>
              Данное согласие вступает в силу с даты подписания и может быть отозвано мною либо моим представителем в любое время путем подачи Оператору соответствующего письменного заявления в произвольной форме.
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  name: 'PersonalAgreementDialog',
  props: {
      dialog: Boolean,
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');  
    },
  },
};
</script>

<style lang="scss" scoped>
.close-dialog-button {
    right: 5px;
}
</style>